<div class="cant-see-post">
  <p [innerHTML]="'notify.post.post_not_found' | translate"></p>
  <img src="assets/images/posts/404-post-not-found.svg" alt="Post Not Found SVG image" />
</div>
